import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { AccountsRoutingModule } from './accounts-routing.module';
import { MaterialModule } from './material.module';
import { RootLayoutModule } from 'root-layout';
import { CommonCoreModule } from 'common';
import { ProfileComponent } from '../components/profile/profile.component';
import { ContactsComponent } from '../components/account-details/contacts/contacts.component';
import { CompanyComponent } from '../components/account-details/company/company.component';
import { AccountDetailsComponent } from '../components/account-details/account-details.component';
import { CompanyDetailsComponent } from '../components/account-details/company/company-details/company-details.component';
import { ContactPersonComponent } from '../components/account-details/company/contact-person/contact-person.component';
import { AddressDetailsComponent } from '../components/account-details/company/address-details/address-details.component';
import { NewContactComponent } from '../components/account-details/contacts/new-contact/new-contact.component';
import { EditContactComponent } from '../components/account-details/contacts/edit-contact/edit-contact.component';
import { ContactRemoveComponent } from '../components/account-details/contacts/contact-remove/contact-remove.component';

import { CompanyResolver } from '../resolvers/company.resolver';
import { EditContactResolver } from '../resolvers/edit-contact.resolver';
import { ContactsResolver } from '../resolvers/contacts.resolver';
import { SalutationResolver } from '../resolvers/salutation.resolver';
import { CountryResolver } from '../resolvers/country.resolver';
import { CountyResolver } from '../resolvers/county.resolver';
import { OrganisationTypeResolver } from '../resolvers/organisation-type.resolver';
import { ManageProfileComponent } from '../components/profile/manage-profile/manage-profile.component';
import { PermissionsResolver } from '../resolvers/permissions.resolver';
import { PermissionsComponent } from '../components/account-details/permissions/permissions.component';
import { ContactPermissionsComponent } from '../components/account-details/contacts/contact-permissions/contact-permissions.component';
import { RegistrationSalutationResolver } from '../resolvers/registration-salutation.resolver';
import { RegistrationComponent } from '../components/registration/registration.component';
import { AccountTypeComponent } from '../components/registration/account-type/account-type.component';
import { ContactDetailsComponent } from '../components/registration/contact-details/contact-details.component';
import { FinancialDetailsComponent } from '../components/registration/financial-details/financial-details.component';
import { GeneralDetailsComponent } from '../components/registration/general-details/general-details.component';
import { LicenceTypeComponent } from '../components/registration/licence-type/licence-type.component';
import { PrsDetailsComponent } from '../components/registration/prs-details/prs-details.component';
import { ContactDetailsHeaderTextComponent } from '../components/registration/contact-details/contact-details-header-text/contact-details-header-text.component';
import { StringArrayToHtmlListPipe } from 'common';
import { CardValueFormatterPipe } from 'common';
import { DashboardHeaderComponent } from '../components/dashboard/dashboard-header/dashboard-header.component';
import { PendingAccountRegistrationResolver } from '../resolvers/pending-account-registration.resolver';

@NgModule({
  declarations: [
    ProfileComponent,
    CompanyComponent,
    NewContactComponent,
    EditContactComponent,
    AccountDetailsComponent,
    CompanyDetailsComponent,
    ContactPersonComponent,
    AddressDetailsComponent,
    ContactsComponent,
    ContactRemoveComponent,
    ManageProfileComponent,
    RegistrationComponent,
    AccountTypeComponent,
    ContactDetailsComponent,
    ContactDetailsHeaderTextComponent,
    FinancialDetailsComponent,
    GeneralDetailsComponent,
    LicenceTypeComponent,
    PrsDetailsComponent,
    PermissionsComponent,
    ContactPermissionsComponent,
    DashboardHeaderComponent,
  ],
  imports: [AccountsRoutingModule, MaterialModule, FormsModule, ReactiveFormsModule, CommonModule, RouterModule, RootLayoutModule, CommonCoreModule],
  providers: [
    CompanyResolver,
    EditContactResolver,
    ContactsResolver,
    SalutationResolver,
    CountryResolver,
    CountyResolver,
    OrganisationTypeResolver,
    PermissionsResolver,
    RegistrationSalutationResolver,
    PendingAccountRegistrationResolver,
  ],
  exports: [
    AccountsRoutingModule,
    ProfileComponent,
    CompanyComponent,
    NewContactComponent,
    EditContactComponent,
    AccountDetailsComponent,
    CompanyDetailsComponent,
    ContactPersonComponent,
    AddressDetailsComponent,
    ContactRemoveComponent,
    RegistrationComponent,
    StringArrayToHtmlListPipe,
    CardValueFormatterPipe,
    DashboardHeaderComponent,
  ],
})
export class AccountsModule {}
